import { Component, OnInit } from '@angular/core';
import { WidgetBaseComponent } from '../../widget-base/widget-base.component';
import { CommonModule } from '@angular/common';
import { ENVIRONMENT } from 'shared/environment/environment';
import { LinkComponent } from 'shared/components/shared/link/link.component';

@Component({
  selector: 'app-widget-fullsize-banner',
  imports: [
    CommonModule,
    LinkComponent
  ],
  templateUrl: './widget-fullsize-banner.component.html',
  styleUrls: ['./widget-fullsize-banner.component.scss']
})
export class WidgetFullsizeBannerComponent extends WidgetBaseComponent implements OnInit {
  public url: string | undefined;

  public imageUrl: string | undefined;
  public description: string | undefined;
  public message: string | undefined;
  public id: string | undefined;
  public cssClass: string | undefined;
  public imageDescription: string | undefined;
  public marginTop: string | undefined;
  public marginRight: string | undefined;
  public marginBottom: string | undefined;
  public marginLeft: string | undefined;
  public backgroundImageStyle: string | undefined;
  public widgetFullsizeBannerHeaderAndMessageTogether: boolean | undefined;

  public ngOnInit(): void {
    this.url = this.widget?.contentWidgetAttributeList?.find(a => a.key?.localeCompare("URL") == 0)?.value;
    this.imageUrl = this.widget?.contentWidgetAttributeList?.find(a => a.key?.localeCompare("ImageUrl") == 0)?.value;
    this.description = this.widget?.contentWidgetAttributeList?.find(a => a.key?.localeCompare("Description") == 0)?.value;
    this.message = this.widget?.contentWidgetAttributeList?.find(a => a.key?.localeCompare("Message") == 0)?.value;
    this.id = this.widget?.contentWidgetAttributeList?.find(a => a.key?.localeCompare("Id") == 0)?.value;

    if (this.id && this.id.includes(' ')) {
      this.id = this.id.split(' ')[0];
    }
    this.cssClass = this.widget?.contentWidgetAttributeList?.find(a => a.key?.localeCompare("CssClass") == 0)?.value;
    this.imageDescription = this.widget?.contentWidgetAttributeList?.find(a => a.key?.localeCompare("ImageDescription") == 0)?.value;
    this.marginTop = this.widget?.contentWidgetAttributeList?.find(a => a.key?.localeCompare("MarginTop") == 0)?.value;
    this.marginRight = this.widget?.contentWidgetAttributeList?.find(a => a.key?.localeCompare("MarginRight") == 0)?.value;
    this.marginBottom = this.widget?.contentWidgetAttributeList?.find(a => a.key?.localeCompare("MarginBottom") == 0)?.value;
    this.marginLeft = this.widget?.contentWidgetAttributeList?.find(a => a.key?.localeCompare("MarginLeft") == 0)?.value;

    this.widgetFullsizeBannerHeaderAndMessageTogether = ENVIRONMENT.widgets?.widgetFullsizeBannerHeaderAndMessageTogether != undefined ? ENVIRONMENT.widgets.widgetFullsizeBannerHeaderAndMessageTogether : false;

    if (this.imageUrl != undefined) {
      this.backgroundImageStyle = `background-image: url("${this.imageUrl}");background-repeat: no-repeat;background-size: contain;background-position: 50% 50%;`;
    }
  }
}
